import type { RestRecord } from '@libs/data-access/entities'
import { Button } from '@libs/ui/ds'
import { useCommonAppTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { deleteRest, deleteRestsFromStore } from 'snap-redux/modules/rests'
import { bindPromiseActionCreators } from 'snap-redux/utils'

type Props = {
  rest: RestRecord
  loading: boolean
  disabled: boolean
  onSuccess: Function
  onError: Function
}

export const EditForm: FC<Props> = ({
  loading,
  disabled,
  onSuccess,
  rest,
  onError
}) => {
  const { t } = useCommonAppTranslation()
  const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false)

  const dispatch = useDispatch()
  const bindedActions = bindPromiseActionCreators(
    {
      deleteRest,
      deleteRestsFromStore
    },
    dispatch
  )

  const onDeleteRest = async () => {
    setIsDeleteLoading(true)
    try {
      await bindedActions.deleteRest(rest.id)

      onSuccess()
    } catch (e) {
      onError(e)
    }
  }

  return (
    <div className='grid w-full grid-cols-2 gap-3'>
      <Button
        loading={isDeleteLoading || loading}
        disabled={loading}
        onClick={onDeleteRest}
        dataTestId='delete-rest'
        variant='secondary'
        intent='danger'
      >
        {t('action.delete')}
      </Button>
      <Button
        fillWidth
        loading={loading}
        disabled={disabled}
        dataTestId='update-rest'
        variant='primary'
        intent='default'
        type='submit'
      >
        {t('action.edit')}
      </Button>
    </div>
  )
}
